import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContractModel } from 'src/app/core/models/contract.model';
import { ENUM_PERMISSIONS } from 'src/app/core/enums/permission.enum';

@Component({
  selector: 'selected-engagements-list',
  templateUrl: './selected-engagements-list.component.html',
  styleUrls: ['./selected-engagements-list.component.scss'],
})
export class SelectedEngagementsListComponent {
  readonly ENUM_PERMISSIONS = ENUM_PERMISSIONS;
  @Input() contracts: ContractModel[] = [];
  @Output() remove = new EventEmitter<ContractModel>();

  removeContract(contract: ContractModel) {
    this.remove.emit(contract);
  }
}
